<template>
  <main-header></main-header>
  <main-sidenav></main-sidenav>
  <main class="container-fluid mm-bg">
    <div class="row">
      <div class="col-12">
        <toast></toast>
        <videocall></videocall>
        <videocall-dyte></videocall-dyte>
        <general-loader></general-loader>
        <weekly-report-modal></weekly-report-modal>
        <router-view />
      </div>
    </div>
  </main>
</template>

<script>
import { computed, defineAsyncComponent, onMounted } from 'vue'
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import VideocallDyte from "@/components/VideocallDyte";

export default {
  components: {
    VideocallDyte,
    MainHeader: defineAsyncComponent(() => import('@/components/HeaderPrincipal.vue')),
    MainSidenav: defineAsyncComponent(() => import('@/components/Sidenav.vue')),
    Toast: defineAsyncComponent(() => import('@/components/shared/Toast.vue')),
    Videocall: defineAsyncComponent(() => import('@/components/Videocall.vue')),
    GeneralLoader: defineAsyncComponent(() => import('@/components/shared/GeneralLoader.vue')),
    WeeklyReportModal: defineAsyncComponent(() => import('@/modules/admin/reports/evaluations/components/WeeklyReportModal.vue'))
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const currentLang = computed(() => store.getters['getLang']);

    onMounted(async () => {
      $.datepicker.regional['es'].dayNamesMin = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
      if (currentLang.value === 'es') {
        $.datepicker.setDefaults($.datepicker.regional['es']);
      } else {
        $.datepicker.setDefaults($.datepicker.regional['']);
      }

      // Cargar configuración del tenant cuando se monta el layout
      const loggedUser = store.getters['auth/getLoggedUser'];

      if (loggedUser && loggedUser.tenant_id) {
        await store.dispatch('loadTenantConfiguration');
      }
    })

    return {
      route
    }
  }
}
</script>

<style scoped>
main {
  width: 100%;
  min-height: 100%;
  height: auto;
  overflow-x: hidden;
  padding-top: 66.5px;
}

main.mm-bg {
  background-color: var(--mm-main-background) !important;
}
</style>
